// extracted by mini-css-extract-plugin
module.exports = {"title":"ClientModal_title__1vMpA","detailsCard":"ClientModal_detailsCard__PG0VE","cardTitle":"ClientModal_cardTitle__2crrg","clientDialog":"ClientModal_clientDialog__HYuud"};